const normalize = (value) => String(value || "").trim().replace(/\s+/g, " ");

export const splitFullName = (fullName) => {
  const normalized = normalize(fullName);
  if (!normalized) return { nombre: "", apellido: "" };

  const parts = normalized.split(" ").filter(Boolean);
  if (parts.length === 1) return { nombre: parts[0], apellido: "" };

  return {
    nombre: parts[0],
    apellido: parts.slice(1).join(" "),
  };
};

export const buildFullName = ({ nombre, apellido, fallback = "" } = {}) => {
  const normalizedNombre = normalize(nombre);
  const normalizedApellido = normalize(apellido);
  const fullName = [normalizedNombre, normalizedApellido].filter(Boolean).join(" ").trim();
  return fullName || normalize(fallback);
};

export const resolveNameParts = ({ nombre, apellido, titular, displayName } = {}) => {
  const normalizedNombre = normalize(nombre);
  const normalizedApellido = normalize(apellido);

  if (normalizedNombre || normalizedApellido) {
    return { nombre: normalizedNombre, apellido: normalizedApellido };
  }

  return splitFullName(titular || displayName || "");
};

